import { convertToExportedView } from '@estee/elc-service';
import { SEARCH_RESULTS } from '@estee/elc-service-view-names';
import { ISearchResults } from './SearchResults';
import serviceNames from '~setup/SearchService';

/*eslint no-restricted-syntax: ["off"]*/
export default convertToExportedView<ISearchResults>(
    () => import('./SearchResults'),
    SEARCH_RESULTS,
    serviceNames.searchResultsViewController
);
